export default __webpack_public_path__ + "static/enterprise-bd4d54b90d04515f901af995fe046454.png";